'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGroup = function ButtonGroup(_ref) {
  var className = _ref.className,
      block = _ref.block,
      size = _ref.size,
      pill = _ref.pill,
      square = _ref.square,
      color = _ref.color,
      border = _ref.border,
      disabled = _ref.disabled,
      _ref$children = _ref.children,
      children = _ref$children === undefined ? [] : _ref$children,
      props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'block', 'size', 'pill', 'square', 'color', 'border', 'disabled', 'children']);
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, props, { className: (0, _classnames2.default)('button-group', className, { 'button-group-block': block }) }),
    _react2.default.Children.toArray(children).map(function (child) {
      return _react2.default.cloneElement(child, {
        size: child.props.size === undefined ? size : child.props.size,
        pill: child.props.pill === undefined ? pill : child.props.pill,
        square: child.props.square === undefined ? square : child.props.square,
        color: child.props.color === undefined ? color : child.props.color,
        border: child.props.border === undefined ? border : child.props.border,
        disabled: child.props.disabled === undefined ? disabled : child.props.disabled
      });
    })
  );
};

exports.default = ButtonGroup;